import {
  Card,
  CardContent,
  Typography,
  Box,
  Badge,
  Divider,
  IconButton,
  Chip,
  Stack,
} from "@mui/material";
import {
  People as PeopleIcon,
  CalendarMonth as CalendarMonthIcon,
  LocationOn as LocationOnIcon,
  Straighten as StraightenIcon,
  Star as StarIcon,
  ArrowForward as ArrowForwardIcon,
} from "@mui/icons-material";

/**
 * Card component for displaying a shared dive
 *
 * @param {Object} props
 * @param {Object} props.dive - Dive data object
 * @param {Function} props.onViewDetails - Function to call when viewing details
 */
function SharedDiveCard({ dive, onViewDetails }) {
  const formattedDate = new Date(dive.diveDate).toLocaleDateString();
  console.log("Dive data:", dive);

  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: 3,
        },
        position: "relative",
      }}
    >
      <CardContent sx={{ flexGrow: 1, pb: 1 }}>
        <Typography variant="h6" component="div" noWrap sx={{ mb: 1, pr: 4 }}>
          {dive.divesite.uddf.divesite.site?.name || "Unnamed Dive Site"}
        </Typography>

        <Stack spacing={1}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <CalendarMonthIcon
              fontSize="small"
              sx={{ mr: 1, color: "text.secondary" }}
            />
            <Typography variant="body2">{formattedDate}</Typography>
          </Box>

          {dive.divesite.uddf.divesite.site.geography.address?.city && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <LocationOnIcon
                fontSize="small"
                sx={{ mr: 1, color: "text.secondary" }}
              />
              <Typography variant="body2" noWrap>
                {dive.divesite.uddf.divesite.site.geography.address.city}
              </Typography>
            </Box>
          )}

          {dive.diveRating && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <StarIcon
                fontSize="small"
                sx={{ mr: 1, color: "text.secondary" }}
              />
              <Typography variant="body2">
                {dive.diveRating}/5 rating
              </Typography>
            </Box>
          )}
        </Stack>
      </CardContent>

      <Divider />

      <Box
        sx={{
          p: 1,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Chip
          icon={<PeopleIcon />}
          label={`Shared with ${dive.sharedWithCount}`}
          size="small"
          color="primary"
          variant="outlined"
        />

        <IconButton size="small" onClick={onViewDetails} color="primary">
          <ArrowForwardIcon />
        </IconButton>
      </Box>
    </Card>
  );
}

export default SharedDiveCard;
